export function getOrderedComparisonKeys({
    comparisonSummary,
    leftSelectedJob,
    rightSelectedJob,
    leftSelectedVersion,
    rightSelectedVersion
}) {
    const allKeys = Object.keys(comparisonSummary);
    const orderedKeys = [];

    const formatVersion = (v) => {
        if (!v) return "";
        const str = v.toString();
        return str.includes(".") ? `V${str}` : `V${str}.0`;
    };

    const leftVersionKey = formatVersion(leftSelectedVersion?.data?.version);
    const rightVersionKey = formatVersion(rightSelectedVersion?.data?.version);

    const leftKey = allKeys.find((key) =>
        (
            key.includes(leftSelectedJob?.data?.job_code) ||
            key.includes(leftSelectedJob?.data?.sb_requisition_number)
        ) &&
        key.includes(leftVersionKey)
    );
    if (leftKey) orderedKeys.push(leftKey);

    const rightKey = allKeys.find((key) =>
        (
            key.includes(rightSelectedJob?.data?.job_code) ||
            key.includes(rightSelectedJob?.data?.sb_requisition_number)
        ) &&
        key.includes(rightVersionKey)
    );
    if (rightKey) orderedKeys.push(rightKey);

    if (comparisonSummary["Key Differences"]) {
        orderedKeys.push("Key Differences");
    }

    return orderedKeys;
}
